import link from "@/scripts/host.js";
import handleError from '@/scripts/handleError.js'


export default {
  name: "forgotPass",
  data() {
    return {
      newPassword: "",
      repeatPassword: "",
      invalid: false
    };
  },
  methods: {
    changePassword() {
      if (this.newPassword !== this.repeatPassword) {
        this.invalid = true;
      } else {
        this.axios({
          method: "post",
          url: `${link.hostLink}Account/ChangePassword`,
          data: { oldPasswrd: this.oldPassword, newPassword: this.newPassword }
        })
          .then(function() {
          })
          .catch(function(error) {
            handleError(error.response)
          });
        this.invalid = false;
      }
    }
  },
  mounted() {}
}
